
// This will doubtless become more comprehensive as needed
export const parseSeasonCode = (code: string) => {
  const [ year, crop ] = code.split(':');
  return {
    year,
    crop
  };
};


